import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import dayjs from "dayjs";
import Pagination from "../../extra/Pagination";
import ToggleSwitch from "../../extra/ToggleSwitch";
import LazyImage from "../../../common/ImageFallback";
import UserImage from "../../../assets/images/8.jpg";
import { getSuspiciousUsers, isActiveUser } from "../../store/user/user.action";

function SuspiciousUsers(props) {
  const { getSuspiciousUsers, isActiveUser } = props;

  const [mode, setMode] = useState("device"); // "device" | "ip"
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);

  const { suspiciousClusters, totalSuspicious, suspiciousThreshold } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    getSuspiciousUsers(mode, page, size);
  }, [getSuspiciousUsers, mode, page, size]);

  const handlePageChange = (pageNumber) => setPage(pageNumber);
  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleMode = (newMode) => {
    if (newMode !== mode) {
      setPage(1);
      setMode(newMode);
    }
  };

  const handleBlock = (user) => {
    const block = user?.isBlock === false; // true => block, false => unblock
    isActiveUser(user?._id, "user", block);
    // refresh the clusters so the new block state is reflected
    setTimeout(() => getSuspiciousUsers(mode, page, size), 700);
  };

  const modeLabel = mode === "ip" ? "IP Address" : "Device ID";

  return (
    <div className="mainSuspicious">
      <div className="user-table real-user mb-3">
        <div
          className="user-table-top"
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}
        >
          <div>
            <h5 style={{ fontWeight: "500", fontSize: "20px", marginBottom: "4px", marginTop: "5px" }}>
              Suspicious Users
            </h5>
            <p style={{ margin: 0, fontSize: "13px", opacity: 0.7 }}>
              Accounts grouped by {modeLabel} with{" "}
              <b>{suspiciousThreshold}+</b> accounts (auto-flagged as suspicious).
            </p>
          </div>

          <div style={{ display: "flex", gap: "8px" }}>
            <button
              type="button"
              className="btn"
              onClick={() => handleMode("device")}
              style={{
                padding: "8px 16px",
                borderRadius: "8px",
                border: "1px solid #d0d0d0",
                fontWeight: "600",
                background: mode === "device" ? "#e03131" : "transparent",
                color: mode === "device" ? "#fff" : "inherit",
              }}
            >
              By Device
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => handleMode("ip")}
              style={{
                padding: "8px 16px",
                borderRadius: "8px",
                border: "1px solid #d0d0d0",
                fontWeight: "600",
                background: mode === "ip" ? "#e03131" : "transparent",
                color: mode === "ip" ? "#fff" : "inherit",
              }}
            >
              By IP Address
            </button>
          </div>
        </div>

        {(!suspiciousClusters || suspiciousClusters.length === 0) && (
          <div style={{ padding: "40px", textAlign: "center", opacity: 0.6 }}>
            No suspicious {modeLabel} clusters found.
          </div>
        )}

        {suspiciousClusters?.map((cluster) => (
          <div
            key={cluster?._id}
            className="suspicious-cluster mb-4"
            style={{ border: "1px solid #f0d0d0", borderRadius: "10px", overflow: "hidden" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "#fff5f5",
                padding: "10px 16px",
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              <div style={{ fontSize: "13px" }}>
                <span style={{ opacity: 0.6 }}>{modeLabel}:</span>{" "}
                <b style={{ wordBreak: "break-all" }}>{cluster?._id || "-"}</b>
              </div>
              <span
                style={{
                  background: "#e03131",
                  color: "#fff",
                  padding: "3px 12px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  fontWeight: "700",
                }}
              >
                {cluster?.count} accounts
              </span>
            </div>

            <table width="100%" className="primeTable text-center">
              <thead>
                <tr>
                  <th className="text-nowrap">USER</th>
                  <th className="text-nowrap">ID</th>
                  <th className="text-nowrap">EMAIL</th>
                  <th className="text-nowrap">{mode === "ip" ? "DEVICE ID" : "IP ADDRESS"}</th>
                  <th className="text-nowrap">REGISTERED</th>
                  <th className="text-nowrap">LAST LOGIN</th>
                  <th className="text-nowrap">BLOCK</th>
                </tr>
              </thead>
              <tbody>
                {cluster?.users?.map((user) => (
                  <tr key={user?._id}>
                    <td>
                      <div className="d-flex align-items-center">
                        <LazyImage imageSrc={user?.image ? user?.image : UserImage} width="40px" height="40px" />
                        <span className="text-capitalize text-nowrap ms-2">{user?.fullName}</span>
                      </div>
                    </td>
                    <td><span className="text-nowrap">{user?.uniqueId}</span></td>
                    <td><span className="text-lowercase">{user?.email}</span></td>
                    <td>
                      <span className="text-nowrap">
                        {mode === "ip" ? user?.deviceId || "-" : user?.ipAddress || "-"}
                      </span>
                    </td>
                    <td>
                      <span className="text-nowrap">
                        {user?.createdAt ? dayjs(user?.createdAt).format("DD MMM YYYY, hh:mm A") : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="text-nowrap">
                        {user?.lastLogin ? dayjs(user?.lastLogin).format("DD MMM YYYY, hh:mm A") : "-"}
                      </span>
                    </td>
                    <td>
                      <ToggleSwitch value={user?.isBlock} onChange={() => handleBlock(user)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}

        <Pagination
          type={"server"}
          activePage={page}
          rowsPerPage={size}
          userTotal={totalSuspicious}
          setPage={setPage}
          handleRowsPerPage={handleRowsPerPage}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
}

export default connect(null, {
  getSuspiciousUsers,
  isActiveUser,
})(SuspiciousUsers);
